export default __webpack_public_path__ + "static/media/iconNode.fc3bd1ec.png";